import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef, useCallback } from 'react';
import { Search } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import Icon from '../../elementals/icon';
import { ColorNames } from '../../../constants/colorVars';
import useIsMounted from '../../../hooks/useIsMounted';
import { formFieldWrapper } from '../formFieldWrapper';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const SearchWrapper = ({ elmId, stickyOpen, deleteIconEnabled, loading, disabled, compact, showError, onResultSelect: onResultSelectOrig, onFocus: onFocusOrig, onSearchIconClick: onSearchIconClickOrig, onSearchChange: onSearchChangeOrig, onBlur, placeholder, label, className = '', value: initialValue = '', results, ...rest }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [value, setValue] = useState(initialValue);
    const [searchChanging, setSearchChanging] = useState(false);
    const isMounted = useIsMounted();
    const inputRef = useRef();
    const open = useCallback(() => {
        inputRef.current?.select();
        setIsOpen(true);
    }, []);
    const close = useCallback(() => {
        setIsOpen(false);
    }, []);
    const onSearchChange = useCallback((_, { value }) => {
        setSearchChanging(true);
        setValue(typeof value !== 'undefined' ? value : '');
    }, []);
    const onSearchIconClick = useCallback(() => {
        if (!disabled) {
            if (onSearchIconClickOrig) {
                onSearchIconClickOrig();
            }
            else {
                if (inputRef.current) {
                    inputRef.current.focus();
                }
            }
        }
    }, [disabled, onSearchIconClickOrig]);
    const onDeleteIconClick = useCallback(() => {
        if (disabled) {
            return;
        }
        setValue('');
        setSearchChanging(false);
        setIsOpen(false);
        onSearchChangeOrig?.({}, {
            value: '',
        });
    }, [disabled, onSearchChangeOrig]);
    const scrollToTop = useCallback(() => {
        if (isMounted) {
            const menu = document.querySelector('.ui.search.active.visible .results.visible');
            if (menu)
                menu.scrollTop = 0;
        }
    }, [isMounted]);
    const onFocus = useCallback((e, data) => {
        inputRef.current?.select();
        onFocusOrig?.(e, data);
    }, [onFocusOrig]);
    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);
    useEffect(() => {
        if (results?.length && searchChanging) {
            scrollToTop();
            setSearchChanging(false);
        }
    }, [results?.length, searchChanging, scrollToTop]);
    const stickyOpenProps = stickyOpen
        ? {
            onFocus: open,
            onBlur: close,
            open: isOpen,
        }
        : {};
    const showDeleteIcon = deleteIconEnabled && !loading && !disabled && value?.length > 0;
    const showDeleteIconClassName = cx('show-delete-icon');
    const newClassName = classnames({
        compact,
        [className]: true,
        [showDeleteIconClassName]: showDeleteIcon,
    });
    const onResultSelect = useCallback((e, data) => {
        onResultSelectOrig?.(e, data);
        if (!stickyOpen) {
            inputRef.current?.blur();
        }
    }, [onResultSelectOrig, stickyOpen]);
    return (_jsx("div", { className: cx('search'), children: _jsx(Search, { "aria-label": `${elmId}_search`, "data-elm-id": `${elmId}_search`, className: newClassName, icon: _jsxs(_Fragment, { children: [showDeleteIcon && (_jsx(Icon, { className: cx('link', 'delete-icon'), "data-elm-id": `${elmId}_delete_icon`, name: 'xmark', onClick: onDeleteIconClick, iconStyle: 'regular', size: 'medium', color: ColorNames.Error })), _jsx(Icon, { className: cx({ link: !disabled }), "data-elm-id": `${elmId}_search_icon`, name: 'search', onClick: onSearchIconClick, type: 'submit', color: ColorNames.Action })] }), loading: loading, disabled: disabled, placeholder: placeholder || label, input: { input: { ref: inputRef } }, ...rest, onBlur: onBlur, onFocus: onFocus, ...stickyOpenProps, onSearchChange: (e, data) => {
                onSearchChangeOrig?.(e, data);
                onSearchChange(e, data);
            }, results: results, onResultSelect: onResultSelect, autoComplete: 'off', role: 'presentation', value: value }) }));
};
export default formFieldWrapper((fieldProps, showError) => (_jsx(SearchWrapper, { ...fieldProps, showError: showError })));
//# sourceMappingURL=index.js.map